import colors from 'vuetify/es5/util/colors';
import { Theme, VuetifyThemeVariant } from 'vuetify/types/services/theme';

// Any color names added to theme will need to be added to this interface
interface IExtendedTheme extends VuetifyThemeVariant {
    brandGrey: string;
    mainBackground: string;
    headerBackground: string;
}
export default {
    dark: false,
    themes: {
        light: {
            primary: '#00a0df',
            secondary: '#003479',
            accent: '#D91046',
            error: '#DB3939',
            warning: colors.amber.lighten2,
            info: colors.lightBlue.lighten2,
            success: colors.green.lighten2,
            brandGrey: '#4E5054',
            mainBackground: '#f8f7f7',
            headerBackground: '#f8f7f7',
        } as Partial<IExtendedTheme>,
        dark: {
            primary: '#00a0df',
            secondary: '#003479',
            accent: '#D91046',
            error: '#DB3939',
            warning: colors.amber.darken2,
            info: colors.lightBlue.darken2,
            success: colors.green.darken2,
            brandGrey: '#4E5054',
            mainBackground: '#f8f7f7',
            headerBackground: '#f8f7f7',
        } as Partial<IExtendedTheme>,
    },
} as Theme;
